'use client'

import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'
import * as React from 'react'

import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '@ui/web/components'
import { RichText, typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import type { LessonType } from './lesson-overview-button'
import { getLessonTypeInfo } from './lesson-overview-button'

export type { LessonType }

export interface TeacherGuideProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  lessonType: LessonType | null | undefined
  teacherGuide: SerializedEditorState | null
  children?: React.ReactNode
}

export function TeacherGuide({ open, onOpenChange, title, lessonType, teacherGuide, children }: TeacherGuideProps) {
  const typeInfo = getLessonTypeInfo(lessonType)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='srd:max-w-[800px] srd:max-h-[90dvh] srd:overflow-y-auto' showCloseButton={false}>
        <div className='srd:flex srd:flex-col srd:gap-1'>
          <DialogTitle>Panduan Mengajar</DialogTitle>
          <DialogDescription className={cn(typographyVariants({ variant: 'title-md' }), 'srd:text-grey-100')}>
            {title}
          </DialogDescription>
        </div>

        <Alert variant='neutral'>
          <AlertTitle className='srd:sr-only'>{typeInfo.label}</AlertTitle>
          <AlertDescription>
            <strong>{typeInfo.label}:</strong> {typeInfo.description}
          </AlertDescription>
        </Alert>

        {teacherGuide && <RichText data={teacherGuide} />}

        <DialogFooter>
          {children}
          <Button variant='primary' onClick={() => onOpenChange(false)}>
            Kembali
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
